import React from "react";

export const Comments = ({ comments }) => {
  return (
    <div className="serviceComments">
      {comments.length ? (
        comments.map((item, q) => (
          <div className="serviceCommentItem">
            <div className="commentPart1">
              <span className="commentName">{item.customer.name}</span>
              <span className="commentRate">{item.date}</span>
            </div>
            <div className="commentPart2">
              <span className="commentText">{item.content}</span>
              <span className="CommentDate">{item.date}</span>
            </div>
          </div>
        ))
      ) : (
        <div className="noComment">
          <i className="icon-comment" />
          <span>نظری ثبت نشده</span>
        </div>
      )}
    </div>
  );
};
